import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import Overlay from 'ol/Overlay.js';
import Point from 'ol/geom/Point.js';
import TileJSON from 'ol/source/TileJSON.js';
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector.js';
import View from 'ol/View.js';
import {Icon, Style} from 'ol/style.js';
import {Tile as TileLayer, Vector as VectorLayer, Image as ImageLayer} from 'ol/layer.js';
import {fromLonLat,toLonLat} from 'ol/proj';
import OSM from 'ol/source/OSM.js';
import ImageWMS from 'ol/source/ImageWMS.js';

//https://openlayers.org/en/latest/examples/turf.html
//DUH: select ST_BUFFER(ST_UNION(r.geom),0.05) from dechinees.restaurant r , materialized view ?


const nLLonLat = [5, 52];
const nLLonLatWebMercator = fromLonLat(nLLonLat);

const iconFeature = new Feature({
  geometry: new Point([0, 0]),
  name: 'Null Island',
  population: 4000,
  rainfall: 500,
});

const iconStyle = new Style({
  image: new Icon({
    anchor: [0.5, 46],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: 'icon.png',
  }),
});


iconFeature.setStyle(iconStyle);

const vectorSource = new VectorSource({
  features: [iconFeature],
});

const vectorLayer = new VectorLayer({
  source: vectorSource,
});
const osm = new TileLayer({
  title: 'osm',
  type: 'base',
  visible: true,
  source: new OSM()
});

// const rasterLayer = new TileLayer({
//   source: new TileJSON({
//     url: 'https://a.tiles.mapbox.com/v3/aj.1x1-degrees.json?secure=1',
//     crossOrigin: '',
//   }),
// });
 var style1 = function(feature) {
    if (feature.get("id") == "1") {
        return greenStyle;
    }
    else  {
        return redStyle;
    }
}

const parkplatzIconStyle = new Style({
  image: new Icon({
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: 'https://data.mijnlieff.nl/images/icons/wegrestaurant-20x20.png',
  })
});



const chineesfromjson = new VectorLayer({
  title: 'Restaurant',
 // background: '#1a2b39',
  //minZoom: 8,
  source: new VectorSource({
    //url: 'https://data.mijnlieff.nl/geodata/europe/nl/chineesrestaurant/chinees.geojson',
    url: 'https://geoserver.mijnlieff.nl/geoserver/dechinees/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=dechinees:restaurant&outputFormat=application%2Fjson',
    format: new GeoJSON(),
  }),
  style: parkplatzIconStyle,
});

    // url: 'https://geoserver.mijnlieff.nl/geoserver/dechinees_dev/ows?service=WFS&version=1.0&request=GetFeature&typeName=dechinees_dev:restaurant&outputFormat=application/json',


const myImageLayer = new ImageLayer({
source: new ImageWMS({
  url: 'https://geoserver.mijnlieff.nl/geoserver/dechinees/wms',
  params: {'LAYERS': 'dechinees:restaurant5kbuffer'},
  ratio: 1,
  serverType: 'geoserver',
})
});

const restaurantvoronoiLayer = new ImageLayer({
source: new ImageWMS({
  url: 'https://geoserver.mijnlieff.nl/geoserver/dechinees/wms',
  params: {'LAYERS': 'dechinees:restaurantvoronoi'},
  ratio: 1,
  serverType: 'geoserver',
})
});

// const vectorSource = new VectorSource({
//   format: new GeoJSON(),
//   url: function (extent) {
//     return (
//       'https://geoserver.mijnlieff.nl/geoserver/dechinees_dev/ows?service=WFS&version=1.0&request=GetFeature&typeName=dechinees_dev:restaurant&outputFormat=application/json'
//     );
//   },
//   strategy: bboxStrategy,
// });


const map = new Map({
  layers: [osm, myImageLayer, restaurantvoronoiLayer, chineesfromjson],
  target: document.getElementById('map'),
  view: new View({
    center: nLLonLatWebMercator,
    zoom: 8,
  }),
});

const element = document.getElementById('popup');

const popup = new Overlay({
  element: element,
  positioning: 'bottom-center',
  stopEvent: false,
});
map.addOverlay(popup);

let popover;
function disposePopover() {
  if (popover) {
    popover.dispose();
    popover = undefined;
  }
}
// display popup on click
map.on('click', function (evt) {
  const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    return feature;
  });
  disposePopover();
  if (!feature) {
    return;
  }
  popup.setPosition(evt.coordinate);
  popover = new bootstrap.Popover(element, {
    placement: 'top',
    html: true,
    content: feature.get('name') + ' - ' + feature.get('city') + '<br>' + "<a href='https://etc.mijnlieff.nl/dechinees/details.php?id=" +feature.get('id') + "'>Details</a>"
  });
  popover.show();
});
// "<a href='https://etc.mijnlieff.nl/dechinees/map_detail/dist/index.html?id=" + feature.get('id') + ">Details</a>"
// change mouse cursor when over marker
map.on('pointermove', function (e) {
  const pixel = map.getEventPixel(e.originalEvent);
  const hit = map.hasFeatureAtPixel(pixel);
  map.getTarget().style.cursor = hit ? 'pointer' : '';
});
// Close the popup when the map is moved
map.on('movestart', disposePopover);
